// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3971":"css/app.6792","9043":"css/admin-app.6792"}[chunkId] + ".css";
};